'use strict';


/*@ngInject*/
export function capitalizeFilter() {
  return function(input) {
    return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
}


export default angular.module('fplTruescapeComApp.capitalize', [])
  .filter('capitalize', capitalizeFilter)
  .name;



// WEBPACK FOOTER //
// ./client/components/filters/capitalize/capitalize.filter.js